import $ from 'jquery';
import 'datatables.net';
import datepickerFactory from 'jquery-datepicker';
import { LocationApi, ReservationApi } from '../api/apicollection';

export default function ReservationViewModel() {
    datepickerFactory($);

    let dt = $("#reservationUnits").DataTable({
                "paging":   false,
                "ordering": false,
                "info":     false,
                "searching":   false,
                columnDefs: [
                    { width: '45%', targets: 2 }
                ],
    });

    this.section = ko.observableArray();

    this.tabs = ko.observableArray(['Small', 'Medium', 'Large', 'XLarge', 'All']);
    this.tab = ko.observable(localStorage.getItem('tab') ?? 'All');
    localStorage.removeItem('tab');

    this.reservationUnits = ko.observableArray([]);
    this.filteredUnits = ko.observableArray([]);

    this.location = ko.observable();
    this.startD = ko.observable();
    this.options = ko.observable();
    let initialLoad = true;

    this.reservationDate = ko.observable();
    this.selectedUnit = ko.observable();

    this.changeTab = (tab, e) => {
        this.tab(tab);
        let tablinks = document.getElementsByClassName("tab__tab-button");
        let date = this.startD();
        let option = this.options();

        for (let i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        (e != undefined)
            ? e.currentTarget.className += ' active'
            : document.getElementById(this.tab()).className += ' active';

        let resUnits = this.reservationUnits();
        if (tab === 'All') {
            this.filteredUnits(resUnits.sort((a, b) => (a.size > b.size)));
            checkNotAvailable(resUnits);

            if (!initialLoad) this.createCalendars(date, option);

            initialLoad = false;
            return;
        }

        let max = 0;
        let min = 0;

        if (tab === 'Small') {max = 100; min = 0;}
        if (tab === 'Medium') {max = 150; min = 101;}
        if (tab === 'Large') {max = 250; min = 151;}
        if (tab === 'XLarge') {max = 100000; min = 251;}

        let resp = resUnits.filter(x => x.size <= max && x.size >= min);
        checkNotAvailable(resp);
        let order = resp.sort((a, b) => (a.size > b.size));
        this.filteredUnits(order);

        this.createCalendars(date, option);
    };

    this.bulidReservationList = () => {
        const Small = { name: 'Small', max: 100, min: 0, data: [] }
        const Medium = { name: 'Medium', max: 150, min: 101, data: [] }
        const Large = { name: 'Large', max: 250, min: 151, data: [] }
        const XLarge = { name: 'XLarge', max: 100000, min: 251, data: [] }

        const unitTypes = [Small, Medium, Large, XLarge];

        let resp = this.reservationUnits();
        unitTypes.forEach((unitType) => {
            unitType.data = resp.filter(x => x.size <= unitType.max && x.size >= unitType.min);
            unitType.data.sort((a, b) => (a.size - b.size));
        });
        this.section(unitTypes.filter(x => x.data.length > 0));
    };

    this.showReservationDate = function (unit) {
        let reservationDate = document.getElementById('reservationDate');

        if (window.getComputedStyle(reservationDate).visibility === 'hidden')
        {
            this.selectedUnit = unit;
            document.getElementById('reservationDate').style.visibility = 'visible';
            document.getElementById('rentNow').setAttribute('disabled', 'disabled');
            document.body.style.overflow = 'hidden';

            let date = this.startD();
            let option = this.options();
            this.createCalendars(date, option);
        }


    };

    this.hideReservationDate =() => {
        document.getElementById('reservationDate').style.visibility = 'hidden';
        document.getElementById('rentNow').removeAttribute('disabled');
        document.body.style.overflow = 'visible';
    }

    this.getReservationDate = () => {
        let unit = this.selectedUnit;
        let moveInDate = document.getElementById('moveInDate').value;

        window.location.replace(`/reservation/insurance?rentableInventoryID=${unit.rentableInventoryId}&roomRate=${unit.unitRate}&unitCaption=${unit.dimensions}&isReservation=true&moveInDate=${moveInDate}&description=${unit.description}&isParking=${unit.isParking}`);
    }

    this.Reserve = (index, unit) => {
        let moveInDate = $(`#moveInDate${index()}`).val();
        window.location.replace(`/reservation/insurance?rentableInventoryID=${unit.rentableInventoryId}&roomRate=${unit.unitRate}&unitCaption=${unit.dimensions}&isReservation=true&moveInDate=${moveInDate}&description=${unit.description}&isParking=${unit.isParking}`);
    };
    this.RentNow = (unit) => {
      let location = this.location();
      window.location.replace(`/reservation/insurance?rentableInventoryID=${unit.rentableUnits[0]}&roomRate=${unit.unitRate}&unitCaption=${unit.dimensions}&isReservation=false&locationTimeZone=${location.locationTimeZone}&description=${unit.description}&isParking=${unit.isParking}`);
    };

    this.Load = () => {
        ReservationApi.getReservationData().then(data => {
            $('#loadingSpinner').hide();
            this.reservationUnits(data.data);

            if (document.getElementById('reservation-table')) {
                this.changeTab(this.tab());
            } else {
                this.bulidReservationList();
            }

            LocationApi.getLocationData().then(data => {
                let location = data.data;
                this.location(location);
                let reservableDates = location.allowableReservationDates;
                let maxReservationDate = location.daysInFutureExternalReservationsMadeBy;
                let startDate = new Date();
                this.startD(startDate);
                startDate.setDate(startDate.getDate()+1);

                let dateOptions = {
                    dateFormat: 'mm/dd/yy',
                    minDate: 0,
                    maxDate: maxReservationDate
                };

                if (reservableDates && reservableDates.length > 0) {
                    startDate = reservableDates[0];
                    dateOptions.beforeShowDay = function(date) {
                        let available = $.inArray(date, reservableDates) > -1;

                        if (available) {
                            return [1]; //return available date
                        } else {
                            return [0]; //return not available
                        }
                    };
                }

                this.options(dateOptions);
                this.createCalendars(startDate, dateOptions);
            });
        });
    };

    this.Load();


    this.createCalendars = (startDate, options) => {
        $('.reserve-date__move-in').each(function() {
            $(this).datepicker('destroy');
            $(this).datepicker(options);
            $(this).datepicker('setDate', startDate);
        });
    }
    return this;
}

function checkNotAvailable(resp) {
    if (resp.length < 1) {
        document.querySelector('#reservation_units_body').innerHTML = "<div class='not-available' style='width: 100px; padding: 1em;'>Not Available</div>";
    } else {
        let checkDiv = document.querySelector('.not-available');
        if (checkDiv !== null) {
            checkDiv.innerHTML = '';
        }
    }
}